import { FC } from 'react';
import TextCarousel from './TextCarousel';
import _ from 'lodash';
import UserAuth from './UserAuth';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import classNames from 'classnames';

const BannerSection: FC = () => {
  const combinedClassName = classNames('banner-section', ApplicationDomainUtility.partnerName);
  const isIndianVersion = ApplicationDomainUtility.isIndiaVersion;

  return (
    <section className={combinedClassName}>
      <div className="banner-section__hero">
        <TextCarousel />
        <div className="description">
          For any trading goal, make it easier to build, test, and deploy strategies confidently with
          <span> {_.capitalize(ApplicationDomainUtility.partnerName)}.</span>
        </div>
        <UserAuth />
      </div>

      {/* This is absolute */}
      <div className="banner-section__image">
        <img src="/bannerElipse.svg" alt="banner" className="banner-image" />
      </div>

      {!ApplicationDomainUtility.isB2b && (
        <div className="stats-bar">
          <div className="stat-item">
            <span className="stat-number">{isIndianVersion ? '150K+' : '10K+'}</span>
            <span className="stat-label">Users</span>
          </div>
          {
            isIndianVersion && (
              <>
                <div className="divider"></div>
                <div className="stat-item">
                  <span className="stat-number">40+</span>
                  <span className="stat-label">Brokers</span>
                </div>
              </>
            )
          }
          <div className="divider"></div>
          <div className="stat-item">
            <span className="stat-number">2Cr+</span>
            <span className="stat-label">Backtest Done</span>
          </div>
          <div className="divider"></div>
          <div className="stat-item">
            <span className="stat-number">9Cr+</span>
            <span className="stat-label">Trades taken</span>
          </div>
        </div>
      )}
    </section>
  );
};

export default BannerSection;
